import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const changeStatus = async (id) => {
  return await httpClient.post(`/templates/${id}/change_status/`);
};

const filter = async (query, page, pageSize, _sortBy, _search, _exportCSV) => {
  return await httpClient.get(
    `/templates${query}&page[number]=${page}&page[size]=${pageSize}`,
  );
};

const info = async (params) => {
  return await httpClient.get('/templates/info/', { params: params });
};

const postTemplateDocuments = async (data) => {
  return await httpClient.post(`/templates/`, data, {
    headers: {
      'Content-Type': `multipart/form-data;`,
    },
  });
};

const getCategories = async () => {
  return await httpClient.get('/template_categories/');
};

const postTemplateType = async (data) => {
  return await httpClient.post(`/template_type/`, data);
};

const templateTypeTable = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(
    query,
    page,
    pageSize,
    search,
    sortBy,
    exportCSV,
  );
  const url = exportCSV ? '/template_type/export/' : '/template_type/';
  return await httpClient.get(url, params);
};

export {
  postTemplateType,
  postTemplateDocuments,
  getCategories,
  changeStatus,
  filter,
  info,
  templateTypeTable,
};
